import { gql } from "@apollo/client";

export const WALLET_OFFERS_QUERY = gql`
  query WalletOffers($isStaffView: Boolean) {
    walletOffers(isStaffView: $isStaffView) {
      id
      title
      description
      code
      offerType
      minTopupAmount
      bonusAmount
      cashbackPercent
      maxBonusCap
      validFrom
      validTo
      promoValidityDays
      totalBudget
      perUserLimit
      isActive
      isTargeted
      targetType
      allowedUsersCount
      allowedUsers {
        id
        email
        firstName
        lastName
        phoneNumber
      }
    }
  }
`;

export const CUSTOMER_WALLET_QUERY = gql`
  query CustomerWallet($userId: ID!) {
    wallet(userId: $userId) {
      id
      currency
      currentRealBalance
      currentPromoBalance
      reservedRealBalance
      reservedPromoBalance
      availableRealBalance
      availablePromoBalance
      availableBalance
      totalBalance
      isActive
      ledgerEntries(limit: 50) {
        id
        entryType
        balanceSource
        amount
        balanceAfterReal
        balanceAfterPromo
        referenceType
        referenceId
        description
        createdAt
      }
    }
  }
`;

export const WALLET_CUSTOMER_SEARCH_QUERY = gql`
  query WalletCustomerSearch($query: String!, $first: Int!) {
    search: customers(first: $first, filter: { search: $query }) {
      edges {
        node {
          id
          email
          firstName
          lastName
          phoneNumber
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
